import React from 'react';
import { Line, LineChart, ReferenceLine, ResponsiveContainer, YAxis } from 'recharts';
import { useTheme } from '../../contexts/ThemeContext';
import DashboardSectionTitle from '../../components/shared/DashboardSectionTitle';
import { formatEquityAxisTick } from './format';

export default function BacktestEquity({ equity = [], stale = false }) {
  const { colors } = useTheme();
  const last = equity.length ? equity[equity.length - 1].equity : 0;
  const stroke = last >= 0 ? colors.success : colors.danger;
  return (
    <div data-testid="backtest-equity" style={{ opacity: stale ? 0.55 : 1 }}>
      <DashboardSectionTitle title="P&L" marginBottom={8} as="h3" />
      {equity.length < 2 ? (
        <div style={{ height: 120, display: 'flex', alignItems: 'center', color: colors.textMuted, fontSize: 12 }}>
          Equity after a run
        </div>
      ) : (
        <div style={{ height: 120 }}>
          <ResponsiveContainer width="100%" height="100%">
            <LineChart data={equity} margin={{ top: 4, right: 8, left: 0, bottom: 0 }}>
              <YAxis
                orientation="right"
                width={52}
                tick={{ fontSize: 10, fill: colors.textMuted }}
                stroke={colors.border}
                tickLine={false}
                axisLine={false}
                allowDecimals
                domain={([dataMin, dataMax]) => [
                  Math.min(0, Number(dataMin) || 0),
                  Math.max(0, Number(dataMax) || 0),
                ]}
                tickFormatter={formatEquityAxisTick}
              />
              <ReferenceLine y={0} stroke={colors.textMuted} strokeDasharray="3 3" strokeOpacity={0.55} />
              <Line type="monotone" dataKey="equity" stroke={stroke} strokeWidth={1.6} dot={false} isAnimationActive={false} />
            </LineChart>
          </ResponsiveContainer>
        </div>
      )}
    </div>
  );
}
